module.exports = __webpack_public_path__ + "static/media/ar_letter_red.51097905.png";